import { Archive20Regular } from "../components/_v2/components/SvgIcons/Archive20Regular";
import { BinRecycle20Regular } from "../components/_v2/components/SvgIcons/BinRecycle20Regular";
import { Chat20Regular } from "../components/_v2/components/SvgIcons/Chat20Regular";
import { Clock20Regular } from "../components/_v2/components/SvgIcons/Clock20Regular";
import { Delete20Regular } from "../components/_v2/components/SvgIcons/Delete20Regular";
import { DismissCircle20Regular } from "../components/_v2/components/SvgIcons/DismissCircle20Regular";
import { Drafts20Regular } from "../components/_v2/components/SvgIcons/Drafts20Regular";
import { Folder20Regular } from "../components/_v2/components/SvgIcons/Folder20Regular";
import { FolderMail20Regular } from "../components/_v2/components/SvgIcons/FolderMail20Regular";
import { FolderProhibited20Regular } from "../components/_v2/components/SvgIcons/FolderProhibited20Regular";
import { FolderSearch20Regular } from "../components/_v2/components/SvgIcons/FolderSearch20Regular";
import { FolderSync20Regular } from "../components/_v2/components/SvgIcons/FolderSync20Regular";
import { Important20Regular } from "../components/_v2/components/SvgIcons/Important20Regular";
import { Mailbox20Regular } from "../components/_v2/components/SvgIcons/Mailbox20Regular";
import { MailInbox20Regular } from "../components/_v2/components/SvgIcons/MailInbox20Regular";
import { Send20Regular } from "../components/_v2/components/SvgIcons/Send20Regular";
import { Server20Regular } from "../components/_v2/components/SvgIcons/Server20Regular";
import { IWellKnownFolder } from "../interfaces/IWellKnownFolder";
import React from "react";

export const WellKnownFolders: IWellKnownFolder[] = [
    { name: "archive", icon: <Archive20Regular /> },
    { name: "clutter", icon: <Folder20Regular /> },
    { name: "conflicts", icon: <Important20Regular /> },
    { name: "conversationhistory", icon: <Chat20Regular /> },
    { name: "deleteditems", icon: <Delete20Regular /> },
    { name: "drafts", icon: <Drafts20Regular /> },
    { name: "inbox", icon: <MailInbox20Regular /> },
    { name: "junkemail", icon: <FolderProhibited20Regular /> },
    { name: "localfailures", icon: <DismissCircle20Regular /> },
    { name: "msgfolderroot", icon: <FolderMail20Regular /> },
    { name: "outbox", icon: <Mailbox20Regular /> },
    { name: "recoverableitemsdeletions", icon: <BinRecycle20Regular /> },
    { name: "scheduled", icon: <Clock20Regular /> },
    { name: "searchfolders", icon: <FolderSearch20Regular /> },
    { name: "sentitems", icon: <Send20Regular /> },
    { name: "serverfailures", icon: <Server20Regular /> },
    { name: "syncissues", icon: <FolderSync20Regular /> }
];